import React, { useEffect } from "react";
import { setCredentials } from "../store/slices/authSlice";
import { useDispatch } from "react-redux";

const AuthWrapper = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const storedAuth = JSON.parse(localStorage.getItem("auth"));
    if (storedAuth?.token) {
      dispatch(setCredentials(storedAuth));
    }
  }, []);
  return children;
};

export default AuthWrapper;
